import dayjs from "dayjs";

// Dates the backend stores as a UTC calendar day (expirations, signal days).
// Taking the date part avoids rolling back a day in timezones west of UTC.
export const utcDay = (date) =>
  date ? dayjs(new Date(date).toISOString().slice(0, 10)) : undefined;

// Today's US market date (New York), the default fill date: after midnight in
// Israel it is still the previous trading day there.
export const marketToday = () =>
  dayjs(
    new Date().toLocaleDateString("en-CA", { timeZone: "America/New_York" }),
  );

export const formatDay = (date) =>
  date ? new Date(date).toISOString().slice(0, 10) : "-";

export const formatPercent = (value, digits = 1) =>
  value === null || value === undefined
    ? "-"
    : `${value > 0 ? "+" : ""}${Number(value).toFixed(digits)}%`;

export const formatIv = (iv) =>
  iv === null || iv === undefined ? "-" : `${(iv * 100).toFixed(1)}%`;

export const formatPrice = (value) =>
  value === null || value === undefined ? "-" : Number(value).toFixed(2);

export const describeSizing = (params = {}) =>
  params.orderSizeType === "amount"
    ? `$${params.orderSize}`
    : `${params.orderSize ?? 5}% of equity`;

export const describeWindow = (params = {}) =>
  `${params.minDays ?? "-"}–${params.maxDteBars ?? "-"} bars`;

const MARKET_TZ = "America/New_York";

const isUtcMidnight = (date) =>
  date.getUTCHours() === 0 &&
  date.getUTCMinutes() === 0 &&
  date.getUTCSeconds() === 0 &&
  date.getUTCMilliseconds() === 0;

// Fill time in New York. Manually logged fills store only the day (UTC
// midnight), so they show just the date.
export const formatMarketDateTime = (value) => {
  if (!value) return { day: "-", time: null };
  const date = new Date(value);
  if (isUtcMidnight(date)) return { day: formatDay(date), time: null };
  return {
    day: date.toLocaleDateString("en-CA", { timeZone: MARKET_TZ }),
    time: `${date.toLocaleTimeString("en-GB", {
      timeZone: MARKET_TZ,
      hour: "2-digit",
      minute: "2-digit",
    })} ET`,
  };
};

export const formatMarketDateTimeText = (value) => {
  const { day, time } = formatMarketDateTime(value);
  return time ? `${day} ${time}` : day;
};

export const formatPoints = (value, digits = 1) =>
  value === null || value === undefined
    ? "-"
    : `${value > 0 ? "+" : ""}${Number(value).toFixed(digits)} pts`;
